import { POIUtility } from '../models/POI';

export type PoiHighlightInput = {
  type: string;
  name?: string | null;
  serpName?: string | null;
  description?: string | null;
  lng: number;
  lat: number;
};

export type HikeHighlightPayload = {
  type: string;
  title: string;
  description: string;
  coordinates: [number, number];
  images: [];
};

export function poiToHikeHighlight(poi: PoiHighlightInput): HikeHighlightPayload {
  return {
    type: POIUtility.fromString(poi.type).serverType(),
    title: poi.name || poi.serpName || poi.type,
    description: poi.description || '',
    coordinates: [poi.lng, poi.lat],
    images: [],
  };
}
